declare global {
	interface Window {
		googleAdsId?: string;
	}
}

export default class GoogleEnhancedConversions {
	static trackConversion(form: HTMLFormElement): void {
		if (typeof gtag !== 'function') {
			return;
		}

		if (typeof window.googleAdsId !== 'string' || window.googleAdsId.length === 0) {
			return;
		}

		const emailInput: HTMLInputElement = form.querySelector('.reg-form-email');
		const email: string = emailInput?.value || '';

		gtag('set', 'user_data', { email });
		gtag('event', 'form_submit', { send_to: window.googleAdsId });
	}
}
